<template>
    <div class="top_con">
       <el-form :inline="true" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="角色名">
                    <el-input v-model="role" placeholder="请输入"></el-input>
                </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearSum">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-button type="primary" @click="look(0)" style="margin-top:20px;">添加角色</el-button>
        <el-button type="primary" @click="look(1)" style="margin-top:20px;">编辑</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @current-change="handleSelectionChange" max-height="580px">
            <el-table-column  prop="role"  label="角色名"></el-table-column>
            <el-table-column prop="addtime"  label="添加时间" ></el-table-column>
            <el-table-column prop="upUser"  label="添加人" ></el-table-column>
             <el-table-column prop="cur_user"  label="当前用户" ></el-table-column>
            <el-table-column   label="状态">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="qy(0,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==1">启用</el-link>
                    <el-link :underline="false" @click="qy(1,scope.row.id)" style="margin-right:20px;" v-if="scope.row.status==0">禁用</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="50%">
                <el-form :model="form"  label-width="88px">
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-form-item label="角色名"> 
                                <el-input v-model="form.name" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div style="padding:10px 40px;">
                        <el-checkbox  v-model="form.wx">小程序用户列表</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px;marginBottom:20px">
                            <el-checkbox  v-model="form.wxedit">编辑</el-checkbox>
                        </div>
                        <el-checkbox  v-model="form.md">名单列表</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox-group v-model="checkList" @change="handleCheckAllChange">
                                <el-checkbox label="1"  v-model="checked1">添加</el-checkbox>
                                <el-checkbox label="2" v-model="checked2">编辑</el-checkbox>
                                <el-checkbox label="3" v-model="checked3">删除</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox v-model="form.hmd" >红名单列表</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox-group v-model="checkHList" @change="handleCheckAllChange">
                                <el-checkbox label="2" v-model="checkedh2">编辑</el-checkbox>
                                <el-checkbox label="3" v-model="checkedh3">重新评审</el-checkbox>
                                <el-checkbox label="1" v-model="checkedh4">导出</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox  v-model="form.pj">评价审核</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox  v-model="form.sh">审核通过/拒绝</el-checkbox>
                            <el-checkbox  v-model="form.dels">删除</el-checkbox>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox v-model="form.dz">点赞管理</el-checkbox>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox v-model="form.tj">统计管理</el-checkbox>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox  v-model="form.gw">岗位分类管理</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox  v-model="form.GWAdd">添加岗位分类</el-checkbox>
                            <el-checkbox  v-model="form.GWEdit">编辑岗位分类</el-checkbox>
                            <el-checkbox  v-model="form.GWqj">启用/禁用</el-checkbox>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox  v-model="form.bq">标签管理</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox  v-model="form.BQAdd">添加标签</el-checkbox>
                            <el-checkbox  v-model="form.BQEdit">编辑标签</el-checkbox>
                            <el-checkbox  v-model="form.BQqj">启用/禁用</el-checkbox>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox  v-model="form.user">用户管理</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox  v-model="form.userAdd">添加用户</el-checkbox>
                            <el-checkbox  v-model="form.userEdit">编辑用户</el-checkbox>
                            <el-checkbox  v-model="form.userQj">启用/禁用</el-checkbox>
                        </div>
                        <div style="margin: 30px 0;"></div>
                        <el-checkbox  v-model="form.juese">角色管理</el-checkbox>
                        <div style="margin: 15px 0;"></div>
                        <div style="padding:0 20px">
                            <el-checkbox  v-model="form.jueseAdd">添加角色</el-checkbox>
                            <el-checkbox  v-model="form.jueseEdit">编辑角色</el-checkbox>
                            <el-checkbox  v-model="form.jueseQj">启用/禁用</el-checkbox>
                        </div>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" v-if="tit_type!=1">
                    <el-button type="primary" @click="subAdd" v-if="tit_type==0">确认添加</el-button>
                    <el-button type="primary" @click="subEdit" v-if="tit_type==2">确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
const cityOptions = ['添加', '编辑', '删除'];
import {js_list,js_add,js_detail,js_edit,js_qi_jing} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            userId:'',
            role:'',
            checked1:false,
            checked2:false,
            checked3:false,
            checkedh1:false,
            checkedh2:false,
            checkedh3:false,
            checkedh4:false,
            dialogFormVisible:false,
            zp_tit:"添加角色",
            tit_type:0,
            checkList:[],
            checkHList:[],
            form:{
                name:'',
                wx:false,
                md:false,
                hmd:false,
                pj:false,
                sh:false,
                dels:false,
                dz:false,
                gw:false,
                GWAdd:false,
                GWEdit:false,
                GWqj:false,
                tj:false,
                bq:false,
                BQAdd:false,
                BQEdit:false,
                BQqj:false,
                user:false,
                userEdit:false,
                userAdd:false,
                userQj:false,
                juese:false,
                jueseEdit:false,
                jueseAdd:false,
                jueseQj:false,
            },
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
            id:'',
        }
    },
    methods:{
        handleCurrentChange(val){
            let param ={
                numPerPage:this.value,
                pageNum:val,
                role:this.role
            }
            js_list(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? cityOptions : [];
            this.isIndeterminate = false;
        },
        onSubmit(){
            js_list({role:this.role}).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        clearSum(){
            this.role='';
            js_list().then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        look(idx){
            if(idx==0){
                this.dialogFormVisible=true
                this.form={
                    name:'',
                    wx:false,
                    md:false,
                    hmd:false,
                    pj:false,
                    sh:false,
                    dz:false,
                    tj:false,
                    wxedit:false
                };
                this.checkList=[],
                this.checkHList=[],
                this.checked1=false;
                this.checked2=false;
                this.checked3=false;
                this.checkedh1=false;
                this.checkedh2=false;
                this.checkedh3=false;
                this.checkedh4=false;
                this.zp_tit="添加角色";
                this.tit_type=0;
            }else if(idx==1){
                if(this.multipleSelection!=''){
                    this.dialogFormVisible=true
                    this.zp_tit="编辑";
                    this.tit_type=2;
                    js_detail({id:this.multipleSelection.id}).then(res=>{
                        console.log(res)
                        this.id=res.id;
                        this.form=res.action;
                        this.checkList=res.checkList
                        this.checkHList=res.checkHList
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请先选择要修改的项'
                    });
                }
            }
        },
        qy(idx,id){
            this.$confirm('确定此操作, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let user=JSON.parse(localStorage.getItem('userInfo'))
                    let param ={
                        userId:user.uid,
                        id:id,
                        qy_jy:idx
                    }
                    js_qi_jing(param).then(res=>{
                        if(idx==0){
                            this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                        }else{
                            this.$message({
                                type: 'success',
                                message: '启用成功!'
                            });
                        }
                        js_list().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        subAdd(){
            console.log(this.checkList)
            console.log(this.form)
            this.user=JSON.parse(localStorage.getItem('userInfo'))
            let param ={
                userId:this.user.uid,
                forms:this.form,
                checkList:this.checkList,
                checkHList:this.checkHList
            }
            js_add(param).then(res=>{
                js_list().then(res=>{
                    this.dialogFormVisible=false
                    this.total=res.total;
                    this.tableData=res.list
                });
            });
        },
        subEdit(){
            let param ={
                userId:this.user.uid,
                forms:this.form,
                 id:this.id,
                checkList:this.checkList,
                checkHList:this.checkHList
            }
            js_edit(param).then(res=>{
                js_list().then(res=>{
                    this.dialogFormVisible=false
                    this.total=res.total,
                    this.tableData=res.list
                });
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        js_list().then(res=>{
            this.total=res.total;
            this.tableData=res.list
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RoleManagement.vue